import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import PagingTable from './PagingTable';

/**
 * table to display and select users
 * @param {string} props.name name to identify the component
 * @param {Object} props.formik formik context
 * @param {Object[]} props.directReports list of users
 * @param {boolean} props.singleSelection flag indicating whether to allow one or more than one users to be selected
 * @returns {ReactElement} a component to select users
 */
const SelectUsers = ({
	name,
	formik,
	directReports,
	singleSelection,
	selectUser,
}) => {
	const staff = [
		...directReports.map(dr => ({
			...dr,
			isSelected: formik?.values[name]?.some(x => x?.fiId === dr?.fiId), //conditionally set this based on query params,
		})),
	];

	return (
		<PagingTable
			title='Select Direct Reports'
			error={formik.errors[name]}
			initialValues={staff}
			onChange={value => {
				formik.setFieldTouched(name);
				formik.setFieldValue(
					name,
					value.filter(s => s.isSelected)
				);
				selectUser?.(value.filter(s => s.isSelected)[0].fiId);
			}}
			headCells={[
				{
					id: 'name',
					numeric: false,
					hasHeaderIcon: true,
					label: 'Name',
				},
				{
					id: 'jobTitle',
					numeric: false,
					hasHeaderIcon: false,
					label: 'Job Title',
				},
				{
					id: 'department',
					numeric: false,
					hasHeaderIcon: false,
					label: 'Department',
				},
			]}
			defaultOrderBy='name'
			defaultOrder='asc'
			options={{
				enableKeywordSearch: true,
				singleSelection: singleSelection,
				enableSelectAll: !singleSelection,
				enableCustomSelectAll: !singleSelection,
			}}
		/>
	);
};

SelectUsers.propTypes = {
	name: PropTypes.string.isRequired,
	formik: PropTypes.object.isRequired,
	directReports: PropTypes.arrayOf(PropTypes.object).isRequired,
	singleSelection: PropTypes.bool,
};

export default SelectUsers;
